import React, {useEffect, useImperativeHandle, useState} from "react";
import {Form, Input, Row, Col, Switch, Select, TreeSelect, Divider, InputNumber} from "antd";
import {useHistory} from "react-router-dom";
import {useModel, useModelDispatchers} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";
import {goPage} from "../../layout/pageDefinition";

const {Option} = Select
export default function ({formRef, actionType}) {
    const history = useHistory();
    const [{userInfo}] = useModel("global");
    const {closeNav} = useModelDispatchers("nav");
    const [{brandDict, materialUnitDict, materialSortDict, engineTypeDict, warehouseDict, positionDict},] = useModel("cmDict");

    const [positionOptions, setPositionOptions] = useState(
        positionDict.map(el => ({
            key: el.key,
            label: el.label,
            value: el.value
        }))
    );
    // const [{warehouseList, positionList}, {loadWarehouse, loadPosition}] = useModel("warehouse")
    /*useEffect(() => {
        getEngineTypeDict()
        getBrandDict();
        getMaterialSortDict();
        getOrgDict();
        getMaterialUnitDict()
    }, []);*/
    /*useEffect(()=>{
        loadWarehouse({showMsg: false, data: {pageSize: 100,pageNum:1}});
        console.log(warehouseList)
    },[])*/
    // const selectWarehouse = warehouseList.map(el => ({key: el.key, label: el.warehouseName, value: el.id}))
    const [form] = Form.useForm();
    const [{selectedMaterial}, {insert, update}] = useModel("material");
    const [{supplierList}, {loadSupplierList}] = useModel("supplier");


    useEffect(() => {
        if (actionType === CM_ACTION_TYPE.EDIT) {
            if (selectedMaterial) {
                form.setFieldsValue(selectedMaterial)
                const {materialStatus, warehouseId} = selectedMaterial;
                form.setFieldsValue({"materialStatus": (materialStatus === 0)});
                /*loadPosition({showMsg: false, data: {warehouseId:warehouseId,orgId:userInfo.orgId,pageSize:1000,pageNum:1}}).then(res=>{
                    console.log(res)
                    let {list} = res 
                    let newlist = list.map((el)=>({key:el.key,label:el.shelfCode,value:el.id}))
                    setSelectPosition(newlist)
                });   */
            }
        } else if (actionType === CM_ACTION_TYPE.INSERT) {
            let defaultPositionCode = "W临时货位";
            let position = positionDict.find(el => el.label === defaultPositionCode);

            form.setFieldsValue({"materialStatus": true});
            //仓库
            form.setFieldsValue({"warehouseId": warehouseDict && warehouseDict.length > 0 ? warehouseDict[warehouseDict.length-1].value : null});
            /*loadPosition({showMsg: false, data: {warehouseId:"546616b2eb75445b9cc7ca311a4a3518",orgId:userInfo.orgId,pageSize:1000,pageNum:1}}).then(res=>{
                console.log(res)
                let {list} = res 
                let newlist = list.map((el)=>({key:el.key,label:el.shelfCode,value:el.id}))
                setSelectPosition(newlist)
            });*/
            //货位
            form.setFieldsValue({"shelfId": position ? position.value : null});
        }
        loadSupplierList({showMsg: false, data: {pageSize: 1000, pageNum: 1}})
    }, [selectedMaterial])

    useImperativeHandle(formRef, () => ({
        form: () => {
            return form;
        },
        insert: () => {
            // return console.log(history)
            // return history.goBack()
            form.validateFields().then(data => {
                data.orgId = userInfo.orgId
                data.materialStatus = data.materialStatus || data.materialStatus == undefined ? 0 : 1
                insert({data}).then(res => {
                    if (!!res) {
                        closeNav();
                        goPage(history, "6-1");
                    }
                })
            })
            // let data = form.getFieldsValue()
            // data.orgId = "机构id"
            // // console.log(form.getFieldsValue());
            // insert({ data: form.getFieldsValue() });
        },
        update: () => {
            form.validateFields().then(data => {
                data.id = selectedMaterial.id
                data.orgId = selectedMaterial.orgId
                data.materialStatus = data.materialStatus || data.materialStatus === undefined ? 0 : 1
                update({data}).then(res => {
                    if (!!res) {
                        closeNav();
                        goPage(history, "6-1");
                    }
                });

            })
            // console.log(form.getFieldsValue());

        },
        reset: () => {
            let {materialCode, materialStatus} = selectedMaterial
            form.resetFields();
            if (actionType === CM_ACTION_TYPE.EDIT) {
                form.setFieldsValue({"materialCode": materialCode});
            }
            // form.setFieldsValue({ "materialStatus": !!(materialStatus == 0) });
        },
    }))
    const onWarehouseChange = (value) => {
        let goodsList = positionDict
        .filter(el => el.warehouseId === value)
        .map(el => ({
            key: el.key,
            label: el.label,
            value: el.value
        }))
        setPositionOptions(goodsList);
        // console.log(goodsList,goodsList[goodsList.length-1]['value'])
        // let shelfItem = goodsList[length-1]
        // console.log(shelfItem)
        form.setFieldsValue({"shelfId":goodsList[goodsList.length-1]['value']});

        // console.log(value)
        /*setSelectPosition([])
        loadPosition({
            showMsg: false,
            data: {warehouseId: value, orgId: userInfo.orgId, pageSize: 1000, pageNum: 1}
        }).then(res => {
            // console.log(res)
            let {list} = res
            let newlist = list.map((el) => ({key: el.key, label: el.shelfCode, value: el.id}))
            // newlist
            console.log(newlist)
            setSelectPosition(newlist)
        });*/


    }
    return (
        <Form
            form={form}
            name="material_detail"
            labelCol={{span: 5}}

        >
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="materialCode"
                        label="商品编号"
                        rules={[{required: true, message: '请输入商品编号！'}]}
                    >
                        <Input disabled={actionType === CM_ACTION_TYPE.EDIT} placeholder="商品编号"/>
                    </Form.Item>
                </Col>
                {/* <Col span={6}>
                    <Form.Item
                        name="materialName"
                        label="商品名称"
                    >
                        <Input placeholder="商品名称" />
                    </Form.Item>
                </Col> */}
                <Col span={6}>
                    <Form.Item
                        name="materialBrand"
                        label="品牌"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择品牌"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={brandDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="materialManufacturer"
                        label="产地"
                    >
                        <Input placeholder="产地"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="materialName"

                        label="商品名称"
                        rules={[{required: true, message: '请输入商品名称！！！'}]}
                    >
                        <Input placeholder="商品名称"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="materialUnit"
                        label="单位"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择单位"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={materialUnitDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="supplierId"
                        label="供应商"
                        rules={[{required: false, message: '请选择供应商'}]}
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="供应商"

                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            // options={supplierDict}
                        >
                            {supplierList.map((item, index) => {
                                return <Option key={item.id} value={item.id}>{item.supplierName}</Option>
                            })}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="category"
                        label="商品类型"
                        rules={[{required: true, message: '请选择商品类型'}]}
                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                            placeholder="请选择商品类别"
                            treeDefaultExpandAll
                            onChange={() => {
                            }}
                            treeData={materialSortDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="engineType"
                        label="发动机型号"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="发动机型号"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={engineTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="inventoryCap"
                        label="库存上限"
                        initialValue={0}
                    >
                        <InputNumber placeholder="库存上限"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="specification"
                        label="规格型号"
                    >
                        <Input placeholder="规格型号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="replaceNum"
                        label="图号"
                    >
                        <Input placeholder="图号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="inventoryFloor"
                        label="库存下限"
                        initialValue={0}
                    >
                        <InputNumber placeholder="库存下限"/>
                    </Form.Item>
                </Col>
            </Row>
            {
                actionType === CM_ACTION_TYPE.EDIT ? null :
                    <Row gutter={24}>
                        <Col span={6}>
                            <Form.Item
                                rules={[{required: true, message: '请选择仓库'}]}
                                name="warehouseId"
                                label="仓库"
                            >
                                <Select
                                    showSearch
                                    allowClear={true}
                                    placeholder="选择仓库"
                                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                                    onChange={onWarehouseChange}
                                    options={warehouseDict.map(el => ({
                                        key: el.key,
                                        label: el.label,
                                        value: el.value
                                    }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                rules={[{required: true, message: '请选择货位'}]}
                                name="shelfId"
                                label="货位"
                            >
                                <Select
                                    showSearch
                                    allowClear={true}
                                    placeholder="请先选中左侧的仓库"
                                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                                    options={positionOptions}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
            }

            <Divider orientation="left" plain>商品价格</Divider>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="purchasePrice"
                        label="进货价"
                        rules={[{required: true, message: '请输入进货价！！！'}]}
                    >
                        <InputNumber placeholder="进货价"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="salesPrice"
                        label="销售价"
                        rules={[{required: true, message: '请输入销售价！！！'}]}
                    >
                        <InputNumber placeholder="销售价"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="subSalesPrice"
                        label="二级销价"
                    >
                        <InputNumber placeholder="二级销价"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item
                        name="materialDesc"
                        label="备注"
                    >
                        <Input placeholder="备注"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="materialStatus"
                        label="是否启用"
                        valuePropName="checked"
                    >
                        <Switch size="default"/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}
